import React from "react";
import styled from "styled-components";

const TitleRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.primitiveTokens.spacing.spacing_xl};
  justify-content: space-between;
`;

const TitleText = styled.h1`
  color: ${({ theme }) => theme.resolve("color_text_primary")};
  font-size: ${({ theme }) => theme.resolve("font_size_xl")};
  font-weight: ${({ theme }) => theme.fontWeights.large};
  line-height: ${({ theme }) => theme.resolve("line_height_xl")};
  margin: 0;
`;

const TitleActions = styled.div`
  display: flex;
  align-items: center;
`;

type TablePageTitleProps = {
  title: string;
  /** Filter toggle, view switcher etc — use TableFilterToggle and TableViewToggle */
  actions?: React.ReactNode;
  showTitle?: boolean;
  showTitleActions?: boolean;
};

export function TablePageTitle({
  title,
  actions,
  showTitle = true,
  showTitleActions = false,
}: TablePageTitleProps) {
  if (!showTitle) return null;
  return (
    <TitleRow>
      <TitleText>{title}</TitleText>
      {showTitleActions && actions && <TitleActions>{actions}</TitleActions>}
    </TitleRow>
  );
}
